import axios from "axios";
import { useMutation } from "react-query";
import { ApiRoutes } from "../constants/apiRoutes";
import { QuoteCoTermOptionsRequest, QuoteCoTermOptionsResult } from "../shared/types";

// Issue 33: the date modal's "align to an existing subscription" lookup. The backend returns the
// end dates Microsoft currently offers for this customer + term + start date, grouped into cards.
// A Partner Center transport failure comes back as a 503 with a timestamped text body - the modal
// shows a recoverable error with Retry and keeps its manual-entry option.
export const useCoTermOptions = () =>
  useMutation<QuoteCoTermOptionsResult, unknown, QuoteCoTermOptionsRequest>(
    async request => (await axios.post(ApiRoutes.quoteCoTermOptions, request)).data
  );

export const coTermOptionsError = (error: unknown) => {
  const data = axios.isAxiosError(error) ? error.response?.data : null;
  if (typeof data === "string" && data.trim()) return data;
  if (data && typeof data === "object") return JSON.stringify(data, null, 2);
  return error instanceof Error ? error.message : String(error);
};
